import { useEffect, useState } from 'react';
import { apiClient } from '../apiClient';
import { API_ENDPOINTS } from '../constants';
import { StoreSettings } from '../types';

/**
 * Store commerce rules (delivery charges, minimums, COD availability).
 * Fetched once per page load and shared by every consumer — product cards
 * render in bulk, so this must not fan out into one request per card.
 */
let cache: Promise<StoreSettings> | null = null;

const fetchStoreSettings = (): Promise<StoreSettings> => {
  if (!cache) {
    cache = apiClient
      .get(`${API_ENDPOINTS.SITE_SETTINGS}/store`)
      .then((res) => res.data.store as StoreSettings);
  }
  return cache;
};

/** Clear after an admin save so the storefront picks up new rules */
export const invalidateStoreSettings = () => {
  cache = null;
};

export const useStoreSettings = (): StoreSettings | null => {
  const [settings, setSettings] = useState<StoreSettings | null>(null);

  useEffect(() => {
    let active = true;
    fetchStoreSettings()
      .then((data) => {
        if (active) setSettings(data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return settings;
};

export default useStoreSettings;
